import { Empty } from 'element-ui'

const YEmpty = Empty
YEmpty.$depends = [Empty]
YEmpty.$name = 'y-empty'
YEmpty._name = 'Empty 空状态'

export default YEmpty
